module.exports={"wireguard adapter settings":"Настройки адаптера для wireguard",option1:"Опция 1",option2:"вариант 2"};